import React, { FC } from 'react';
import styles from './organisationViewNode.module.scss';
import { Col, Row } from 'antd';
import { Organization } from 'models/CompanySetup/organization.model';
import { ReactComponent as StarIcon } from 'assets/icons/Star - parent.svg';
import clsx from 'clsx';
import { MetaData } from 'models/MetaData/metaData.model';
import { OrganisationMapPayload } from 'models/CompanySetup/organisationPayload.model';
import { useParams } from 'react-router-dom';
import OptionsDropdown from 'shared/components/OptionsDropdown';
import { stopBubbling } from 'shared/utils/stopBubbling';
import { DeleteContent } from '../../ViewOrganisationMap';
import OrganisationService from 'services/OrganisationService/organisation.service';
import { OrganisationDetailsEnum } from 'constants/organizationDetails.constants';

export interface OrganisationNodeProps {
  organisation: Organization;
  shareType?: string;
  index?: number;
  organisationList?: Organization[];
  organisationListMeta?: MetaData[];
  year?: number;
  validateOrganisationStatus?: (
    params: { year?: number },
    id: number
  ) => Promise<boolean | undefined>;
  setOrganisationMapData?: React.Dispatch<
    React.SetStateAction<OrganisationMapPayload>
  >;
  deleteCallBack?: () => Promise<OrganisationMapPayload>;
}

const OrganisationViewNode: FC<OrganisationNodeProps> = ({
  organisation,
  shareType,
  deleteCallBack,
}) => {
  const { id: organisationId } = useParams();
  const { loading, deleteOrganization } = OrganisationService();
  const { name, organisationYearWise } = organisation;
  const isParent = !organisationYearWise?.parentName;
  const handleDelete = async () => {
    if (!organisation.id || !deleteCallBack) return;
    const response = await deleteOrganization(String(organisation.id));
    if (!response) return;
    await deleteCallBack();
  };

  const deleteModalprops = {
    deleteTitle: OrganisationDetailsEnum.DELETE_MODAL_TITLE,
    onDelete: handleDelete,
    loading: loading,
    deleteContent: DeleteContent,
  };
  return (
    <div
      className={clsx(styles.organisationViewNodeContainer, {
        [styles.selectedOrg]: organisationId == organisation.id,
      })}>
      <Row className={styles.nodeWrapper}>
        {isParent && (
          <Col className={styles.parentIcon}>
            <StarIcon />
          </Col>
        )}
        <Col
          className={clsx({
            [styles.nodeInfo]: true,
            [styles.additionalPadding]: !isParent,
          })}
          span={!isParent ? 24 : 22}>
          <Row
            className={clsx(styles.name, {
              [styles.parentNode]: isParent,
            })}>
            <Col span={22}>{name}</Col>
            {deleteCallBack && !isParent ? (
              <Col onClick={stopBubbling}>
                <OptionsDropdown deleteModalprops={deleteModalprops} />
              </Col>
            ) : null}
          </Row>
          <Row>
            <Col
              span={10}
              className={clsx({
                [styles.locations]: true,
                [styles.additionalVerticalPadding]: !isParent,
              })}>
              {`locations ${organisationYearWise?.totalLocations ?? 0}`}
            </Col>
            {shareType && (
              <Col
                span={14}
                className={clsx({
                  [styles.organisationShare]: true,
                  [styles.additionalVerticalPadding]: !isParent,
                })}>
                <span className={styles.shareType}>{shareType}</span>
                <span className={styles.shareValue}>
                  {`${organisationYearWise?.organizationShare}%`}
                </span>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default OrganisationViewNode;
